import {h} from 'preact'
import {PureComponent} from 'preact-compat'
import axios, {AxiosResponse, CancelTokenSource} from 'axios'

import { Hit } from '../algolia/components'
import TopicListItem from '../topic-list-view/TopicListItem'

interface Props {
  topicIds: Array<number>
  isGuest: boolean,
  pageCount: number,
  attachmentCdn: string
  loaderCallback: (loading: boolean) => void
}

interface State {
  topicsList: Array<Hit>,
}

const topicCache: Record<number, Hit|undefined> = {}

function isHit (maybeHit: Hit|undefined): maybeHit is Hit {
  return !!maybeHit
}

export default class extends PureComponent<Props, State> {
  cancelToken?: CancelTokenSource

  constructor () {
    super()
    this.state = {
      topicsList: []
    }
  }

  async fetchMetadataForTopics () {
    this.cancelToken?.cancel()

    const topicsToFetch = this.props.topicIds.filter(id => {
      return !(id in topicCache)
    })

    this.cancelToken = axios.CancelToken.source();

    let result: AxiosResponse|null = null
    if (topicsToFetch.length) {
      try {
        this.props.loaderCallback(true)
        result = await axios.get('/search/getTopics', {
          params: {
            topicIds: topicsToFetch
          },
          cancelToken: this.cancelToken.token
        })
        this.props.loaderCallback(false)
      } catch {
        this.props.loaderCallback(false)
        return
      }

      if (!result || !result.data) return

      for (const hit of result.data) {
        topicCache[hit.id] = hit
      }
    }

    let joinWith: State['topicsList'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.topicsList
    }

    this.setState({
      topicsList: joinWith.concat(this.props.topicIds.map(id => {
        return topicCache[id]
      }).filter(isHit))
    })
  }

  componentDidMount () {
    this.fetchMetadataForTopics()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.topicIds) === JSON.stringify(prevProps.topicIds)) return

    this.fetchMetadataForTopics()
  }

  render ({isGuest, attachmentCdn}: Props) {
    return <div> {
      this.state.topicsList.map(topic => {
        return <TopicListItem
          key={topic.id}
          topic={topic}
          isGuest={isGuest}
          attachmentCdn={attachmentCdn}
        />
      })
    }</div>
  }
}
